import { useEffect, useState } from "react";
import DataTable, { IColumn } from "../../../components/table/data/DataTable";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BuildingService from "../../../services/building/BuildingService";
import IAdminPageBuildingDetail from "../../../models/adminPage/adminPageBuildingDetail";
import Toolbar from "../../../components/toolbar/Toolbar";
import DownloadTable from "../../../utils/download/downloadDataTable";
import { IFilter } from "../../../components/table/data/filter/DataFilter";

const useBuildingColumns = () => {
    const { t } = useTranslation();

    const columns: IColumn<IAdminPageBuildingDetail>[] = [
        { field: "name", headerName: t("table.building.name") },
        { field: "address", headerName: t("table.building.address") },
        { field: "propertyGroupName", headerName: t("table.property.propertyGroup") },
    ];
    return columns;
};

const BuildingPage = () => {
    const columns = useBuildingColumns();
    const [buildings, setBuildings] = useState<IAdminPageBuildingDetail[]>([]);
    const { t } = useTranslation();
    const [isFilterActive, setIsFilterActive] = useState<boolean>(true);
    const navigate = useNavigate();

    const [filteredRows, setFilteredRows] = useState(buildings);
    const [selectedFilters, setSelectedFilters] = useState<
        Map<string, IFilter>
    >(new Map());

    const visibleFilters: string[] = [];
    selectedFilters.forEach((filter, field) => {
        if (!filter.isActive || !filter.request) return;
        const column = columns.find((column) => column.field === field);
        visibleFilters.push(`${column?.headerName}: ${t(`periodical:filter.${filter.type}`)} ${filter.request}`);
    });

    const downloadTable = new DownloadTable("building", filteredRows, columns, t("table.building.title"), visibleFilters);

    useEffect(() => {
        BuildingService.GetBuildingsDetails().then(setBuildings)
    }, []);

    return (
        <Box sx={{ width: "100%", height: "100%" }}>
            <Toolbar
                onFilterClick={() => setIsFilterActive((old) => !old)}
                onCreate={() => navigate("add")}
                isFilterActive={isFilterActive}
                downloadButtons={[
                    { label: "Excel", onClick: () => downloadTable.GetExcel(t("header.exportedBy"), t("header.exportDate")) },
                    { label: "CSV", onClick: () => downloadTable.GetCSV() },
                    { label: "PDF", onClick: () => downloadTable.GetPDF(t("header.exportedBy"), t("header.exportDate")) }
                ]}
            />

            <DataTable
                dense
                disableFiltrer={!isFilterActive}
                rows={buildings}
                columns={columns}
                onRowClick={(row) =>
                    navigate("edit", { state: { ...row } })
                }
                getRowNavTo={(row) => "edit"}
                onSetFilter={(filteredRows, selectedFilters) => {
                    setFilteredRows(filteredRows)
                    setSelectedFilters(selectedFilters)
                }}
            />
        </Box>
    );
};

export default BuildingPage;
